import { useState } from 'react';

import { endOfYear, startOfYear } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';

import { yearDateRangeAtom, selectedYearChipAtom } from '../../atoms';

import { Box, Typography } from '@mui/material';

import { SelectedYearChip, YearChipSelection } from '../../enum';
import YearChips from './YearChips';
import dayjs from 'dayjs';

export type PeriodType = 'month' | 'week';

export default function YearDateSelector() {
  const { t } = useTranslation('common');
  const [, setYearDateRange] = useRecoilState(yearDateRangeAtom);
  const [selectedYearChip, setSelectedYearChip] =
    useRecoilState(selectedYearChipAtom);
  const [, setShowYearDateRange] = useState(false);

  const handleChipClick = (chip: SelectedYearChip) => {
    setSelectedYearChip(chip);
    setShowYearDateRange(false);

    const today = dayjs();
    const lastYear = dayjs().subtract(1, 'year');
    const nextYear = dayjs().add(1, 'year');

    switch (chip) {
      case YearChipSelection.LAST_YEAR:
        setYearDateRange([
          startOfYear(lastYear.toDate()),
          endOfYear(lastYear.toDate())
        ]);
        break;
      case YearChipSelection.THIS_YEAR:
        setYearDateRange([
          startOfYear(today.toDate()),
          endOfYear(today.toDate())
        ]);
        break;
      case YearChipSelection.NEXT_YEAR:
        setYearDateRange([
          startOfYear(nextYear.toDate()),
          endOfYear(nextYear.toDate())
        ]);
        break;
      default:
        return;
    }
  };

  return (
    <Box display="flex" alignItems="center" gap={2} mb={4}>
      <Typography variant="body1" sx={{ textAlign: 'center' }}>
        {t('adminPortal.realization.selectPeriod')}:
      </Typography>
      <YearChips
        selectedYearChip={selectedYearChip}
        onChipClick={handleChipClick}
      />
    </Box>
  );
}
